import React from "react";
import { withTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";

function ShopListItem(props) {
  const {
    cart,
    variations,
    limited,
    name,
    brand,
    image,
    points,
    userPoints,
    stock,
    t,
    isOrderLimitReached,
  } = props;
  return (
    <div className={isOrderLimitReached ? "product_item no_cursor" : "product_item"}>
      {/* PRODUCT PRICE */}
      {(stock > 0 && !isOrderLimitReached) && (
        <div
          className={
            userPoints - cart.total >= points
              ? "product_price"
              : "product_price disable"
          }
        >
          {points}
        </div>
      )}

      {/* PRODUCT FLAGS */}
      <div className="product_flags">
        {stock === 0 || isOrderLimitReached ? (
          /* UNAVAIBLE PRODUCT */
          <div className="unavaible">{isOrderLimitReached ? t("no_order_available") : t("unavaible")}</div>
        ) : stock <= 10 ? (
          /* DERNIERE PIECES */
          <div className="last_pieces">{t("last_pieces")}</div>
        ) : null}

        { limited && !isOrderLimitReached? (
          /* EDITION LIMITEE */
          <div className="limited_edition">{t("limited_edition")}</div>
        ) : null}
      </div>

      {/* PRODUCT IMAGE */}
      <div className="product_img">
        <LazyLoadImage src={image} alt=""></LazyLoadImage>

        {variations != null ? (
          /* PRODUCT DECLINATION */
          <div className="product_variations">
            {variations.map((variation, index) =>
              index < 4 ? (
                variation.color ? (
                  <div
                    className="variation variation_color"
                    key={index}
                    style={{ backgroundColor: variation.color }}
                  ></div>
                ) : (
                  <div className="variation variation_capacity" key={index}>
                    {variation.capacity + " ml"}{" "}
                  </div>
                )
              ) : (
                ""
              )
            )}
          </div>
        ) : null}
      </div>

      {/* PRODUCT NAME */}
      <div
        className={(stock === 0 || isOrderLimitReached) ? "product_infos stock_out" : "product_infos"}
      >
        <div className="brand">{brand}</div>
        <div className="name">{name}</div>
      </div>
    </div>
  );
}

export default withTranslation()(ShopListItem);
